import React, { useEffect, useMemo, useState, useReducer } from "react";

import { BlogHeader } from "../../components/BlogHeader";
import "./styles.less";
import { Input } from "../../components/Input";
import { PublishConfig } from "./PublishConfig";
import { HeaderPublishTool } from "./HeaderPublishTool";
import { BlogEditor } from "./BlogEditor";

import { useGlobalContext } from "../../context/global/context";
import { blogAxios } from "../../utils/blogAxios";
import { Footer } from "../../components/Footer";

// import { useTranslation } from "react-i18next";

const UP_DATE_ALL = Symbol.for("UP_DATE_ALL");
const UP_DATE_TITLE = Symbol.for("UP_DATE_TITLE");
const UP_DATE_CONTENT = Symbol.for("UP_DATE_CONTENT");
const OLD_ARTICLE = Symbol.for("OLD_ARTICLE");
const UP_DATE_COVER = Symbol.for("UP_DATE_COVER");

const initState = {
  title: "",
  content: "",
  cover: "",
  oldArticle: null,
};

const editPageReducer = (state, action) => {
  switch (action.type) {
    case UP_DATE_ALL: {
      return { ...state, ...action.payload };
    }
    case UP_DATE_TITLE: {
      return { ...state, title: action.payload };
    }
    case UP_DATE_CONTENT: {
      return { ...state, content: action.payload };
    }
    case OLD_ARTICLE: {
      return { ...state, oldArticle: action.payload };
    }
    case UP_DATE_COVER: {
      return { ...state, cover: action.payload };
    }
    default:
      return state;
  }
};

export const EditPage = ({ isEdit = false, id }) => {
  //   const { t } = useTranslation();
  const { state } = useGlobalContext();

  const [editPage, dispatch] = useReducer(editPageReducer, initState);

  // const [title, setTitle] = useState('');
  // const [content, setContent] = useState('');
  // const [cover, setCover] = useState('');
  // const [oldArticle, setOldArticle] = useState();

  useEffect(() => {
    let draft = null;
    if (id) {
      draft = window.localStorage.getItem(`blog-draft-${id}`);
    } else {
      draft = window.localStorage.getItem(`blog-draft-public`);
    }
    if (draft && draft !== "") {
      dispatch({ type: UP_DATE_ALL, payload: JSON.parse(draft) });
    }
  }, [id]);

  useEffect(() => {
    let draft = null;
    if (id) {
      draft = window.localStorage.getItem(`blog-draft-${id}`);
    }
    if (isEdit && !draft) {
      try {
        blogAxios.get(`/articles/${id}`).then(({ data }) => {
          dispatch({
            type: UP_DATE_ALL,
            payload: {
              title: data.title,
              content: data.content,
              cover: data.cover,
              oldArticle: data,
            },
          });
        });
      } catch (e) {
        alert("获取内容失败");
      }
    }
  }, [id, isEdit]);

  useEffect(() => {
    if (window) {
      if (id) {
        window.localStorage.setItem(
          `blog-draft-${id}`,
          JSON.stringify(editPage)
        );
      } else {
        window.localStorage.setItem(
          `blog-draft-public`,
          JSON.stringify(editPage)
        );
      }
    }
  }, [editPage, id]);

  useEffect(() => {
    return () => {
      if (id) {
        const current_draft = window.localStorage.getItem(`blog-draft-${id}`);
        if (current_draft) alert("当前博客有未发布的内容，请点击发布");
      }
    };
  }, [id]);

  const publishDisabled = useMemo(
    /**
     * disable 情况：
     * 无 title
     * 无 内容
     * 非白名单账号
     */
    () =>
      !editPage.title ||
      !editPage.content.replace(/<.*?>/g, "") ||
      (window.location.hostname !== "localhost" &&
        !window._AUTHING__GLOBAL_CONFIG_.blog.publishWhiteList.includes(
          state?.userInfo?.id
        )),
    [editPage.content, editPage.title, state]
  );

  const [publishVisible, setPublishVisible] = useState(false);

  const handlePublish = () => {
    if (!editPage.title) {
      alert("请输入文章标题");
      return;
    }

    if (!editPage.content) {
      alert("请输入内容");
      return;
    }
    setPublishVisible(true);
  };

  return (
    <div className="blog-publish-page">
      <BlogHeader
        noSearch
        operations={
          <HeaderPublishTool
            {...{
              handlePublish,
              cover: editPage.cover,
              setCover: (ev) => {
                dispatch({ type: UP_DATE_COVER, payload: ev });
              },
              publishDisabled,
            }}
          />
        }
      />
      <div className="editor-container">
        <Input
          value={editPage.title}
          onChange={(evt) =>
            dispatch({ type: UP_DATE_TITLE, payload: evt.target.value })
          }
          className="title-input"
          placeholder="请输入标题（最多80个字）"
        />

        <div
          style={{
            flex: 1,
          }}
        >
          <BlogEditor
            handleChange={(ev) => {
              dispatch({ type: UP_DATE_CONTENT, payload: ev });
            }}
            initialValue={editPage.content || editPage.oldArticle?.content}
          />
        </div>
      </div>
      <PublishConfig
        {...{
          title: editPage.title,
          content: editPage.content,
          cover: editPage.cover,
          oldArticle: editPage.oldArticle,
          publishVisible,
          setPublishVisible,
        }}
      />
      <Footer />
    </div>
  );
};
